import { render, staticRenderFns } from "./TransportSubmitted.vue?vue&type=template&id=ce57d1b0"
import script from "./TransportSubmitted.vue?vue&type=script&lang=js"
export * from "./TransportSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports